import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createRouter, createWebHistory } from 'vue-router';
import i18n from '../i18n';
import App from './App.vue';
import PrintableSchedule from './pages/PrintableSchedule.vue';
import PrintableSchedulePrintProxy from './pages/PrintableSchedulePrintProxy.vue';

const routes = [
    {
        name: 'printable-schedule',
        path: '/:route(\\d{1,4}[A-Z]?)?/:direction?',
        component: PrintableSchedule,
    },
    {
        name: 'printable-schedule-print-proxy',
        path: '/:route(\\d{1,4}[A-Z]?)/:direction/imprimer',
        component: PrintableSchedulePrintProxy,
    },
    {
        name: 'printable-schedule-print-proxy-en',
        path: '/:route(\\d{1,4}[A-Z]?)/:direction/print',
        component: PrintableSchedulePrintProxy,
    },
];

const basePath = document.documentElement.lang === 'en'
    ? '/en/schedules-and-routes/bus-schedule/printable-schedules'
    : '/horaires-et-trajets/horaires-des-bus/horaires-imprimer';

const router = createRouter({
    history: createWebHistory(basePath),
    routes,
});

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(i18n);
app.use(router);
app.mount('#vue-printable');
